import prodConfig from './store.prod';
import devConfig from './store.dev';

let configStore;

if (process.env.NODE_ENV === 'production') {
  configStore = prodConfig;
} else {
  configStore = devConfig;
}

export default configStore;
